import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '800px',
    margin: '2rem auto',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    fontFamily: 'sans-serif',
  },
  title: {
    textAlign: 'center',
    marginBottom: '2rem',
    color: '#333',
  },
  content: {
    lineHeight: '1.6',
    color: '#444',
  },
  heading: {
    marginTop: '1.5rem',
    marginBottom: '0.5rem',
    paddingBottom: '0.25rem',
    borderBottom: '1px solid #eee',
    fontWeight: '600'
  },
  paragraph: {
    marginBottom: '1rem'
  },
  list: {
    paddingLeft: '2rem',
    marginBottom: '1rem'
  },
  backLinkContainer: {
    marginTop: '2rem',
    textAlign: 'center'
  },
  backLink: {
    color: '#007bff',
    textDecoration: 'underline',
    fontSize: '0.9em'
  }
};

const renderTermsContent = (contentString) => {
  const lines = contentString.split('\n').filter(line => line.trim() !== '');
  const elements = [];
  let currentListItems = [];

  const flushList = () => {
    if (currentListItems.length > 0) {
      elements.push(
        <ul key={elements.length} style={styles.list}>
          {currentListItems.map((item, index) => <li key={index}>{item}</li>)}
        </ul>
      );
      currentListItems = [];
    }
  };

  lines.forEach((line) => {
    const trimmedLine = line.trim();
    // Unlike privacy policy, "Last Updated" is not expected as the first line of terms content string.
    // It's passed as a separate prop.
    if (/^\d+\.\s/.test(trimmedLine)) { // Numbered heading
      flushList();
      elements.push(<h2 key={elements.length} style={styles.heading}>{trimmedLine}</h2>);
    } else if (trimmedLine.startsWith('- ')) { // List item
      currentListItems.push(trimmedLine.substring(2));
    } else { // Regular paragraph line
      flushList();
      elements.push(<p key={elements.length} style={styles.paragraph} dangerouslySetInnerHTML={{ __html: trimmedLine }} />);
    }
  });

  flushList();
  return elements;
};

function GenericTermsPage({ appName, lastUpdatedDate, termsContent }) {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>{appName ? `${appName} - ` : ''}Terms of Service</h1>
      <div style={styles.content}>
        {lastUpdatedDate && <p style={styles.paragraph}><strong>Last Updated: {lastUpdatedDate}</strong></p>}
        {renderTermsContent(termsContent)}
      </div>
      <div style={styles.backLinkContainer}>
        <RouterLink to="/" style={styles.backLink}>
          &larr; Go back to home
        </RouterLink>
      </div>
    </div>
  );
}

export default GenericTermsPage; 